import { Box } from '@mui/material'
import { UnitType } from '@planning/app/api'
import { AddUnitInfoFormWrapperStore } from '@planning/pages/Order/components/StepperForm/stores/AddUnitInfoFormWrapperStore'
import { CreateOrderPageViewStore } from '@planning/pages/Order/stores/CreateOrderPageViewStore'
import { OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { IFormStore, useRegisterSubFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC, useEffect, useMemo } from 'react'
import { ContainerCreationFormStore } from '../stores/ContainerCreationFormStore'
import { SwapBodyCreationFormStore } from '../stores/SwapBodyCreationFormStore'
import { TrailerCreationFormStore } from '../stores/TrailerCreationFormStore'
import { ContainerCreationForm } from './ContainerCreationForm'
import { SwapBodyCreationForm } from './SwapBodyCreationForm'
import { TrailerCreationForm } from './TrailerCreationForm'

interface IProps {
  containerNumber: string
  unitType: UnitType
  formStore: IFormStore<OrderFormStoreType>
  createOrderPageViewStore: CreateOrderPageViewStore
}

export const AddUnitInfoFormWrapper: FC<IProps> = observer(
  ({ containerNumber, unitType, formStore, createOrderPageViewStore }) => {
    const unitInfoStore = useMemo(() => new AddUnitInfoFormWrapperStore(), [])

    const unitFormStore = useMemo(() => {
      if (unitType === UnitType.Container) {
        return new ContainerCreationFormStore(
          {
            containerNumber,
            operator: createOrderPageViewStore.inheritedOperatorShortName,
          },
          createOrderPageViewStore.isFromRestowPage,
        )
      }

      if (unitType === UnitType.SwapBody) {
        return new SwapBodyCreationFormStore({
          unitNumber: containerNumber,
          type: 'Unknown',
          height: 'Standard',
          operator: createOrderPageViewStore.inheritedOperatorShortName,
        })
      }

      if (unitType === UnitType.Trailer) {
        return new TrailerCreationFormStore({
          iluCode: containerNumber,
          type: 'Unknown',
          operator: createOrderPageViewStore.inheritedOperatorShortName,
        })
      }

      return undefined
    }, [
      containerNumber,
      unitType,
      createOrderPageViewStore.isFromRestowPage,
      createOrderPageViewStore.inheritedOperatorShortName,
    ])

    const registeredUnitFormStore = useRegisterSubFormStore(formStore, 'unitInfo', unitFormStore!)

    useEffect(() => {
      if (registeredUnitFormStore) {
        createOrderPageViewStore.registerStepValidators(0, [
          () => registeredUnitFormStore.validate(),
        ])
      }
    }, [registeredUnitFormStore, createOrderPageViewStore])

    return (
      <Box>
        {unitType === UnitType.Container && (
          <ContainerCreationForm
            createOrderPageViewStore={createOrderPageViewStore}
            formStore={registeredUnitFormStore as ContainerCreationFormStore}
            viewStore={unitInfoStore}
          />
        )}
        {unitType === UnitType.SwapBody && (
          <SwapBodyCreationForm
            store={registeredUnitFormStore as SwapBodyCreationFormStore}
            isOperatorDisabled={!!createOrderPageViewStore.inheritedOperatorShortName}
          />
        )}
        {unitType === UnitType.Trailer && (
          <TrailerCreationForm
            store={registeredUnitFormStore as TrailerCreationFormStore}
            isOperatorDisabled={!!createOrderPageViewStore.inheritedOperatorShortName}
          />
        )}
      </Box>
    )
  },
)
